export default "__VITE_ASSET__DHy2hYFe__"